<script setup lang="ts">
import FormCategoriaExperiencia from '../components/form-categoria-experiencia.vue'
import { useCategoriaExperienciaStore } from '../store/useCategoriaExperienciaStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-experiencia',
    action: 'edit',
    subject: 'categoriaexperiencia',
  },
})

const store = useCategoriaExperienciaStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormCategoriaExperiencia is-editing />
</template>
